import React from "react";
import { PageTitle } from "../../../../_metronic/layout/core";
import GenericReport from "../GenericReport";

const RevenueAnalysisPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[{ title: "Reports", path: "/reports", isActive: false }]}>
        Revenue Analysis
      </PageTitle>
      <GenericReport reportId={9} />
    </>
  );
};

export default RevenueAnalysisPage;
